import {
  ChangeDetectorRef,
  Component,
  Input,
  LOCALE_ID,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { Cliente } from "@sharedV11/classes/clients/client/client.interface";
import { ClienteMapper } from "@sharedV11/classes/clients/client/client.mapper";
import { Contacto } from "@sharedV11/classes/clients/client/contacto.model";
import {
  TipoEntrada,
  TiposEntrada_Respuesta,
} from "@sharedV11/classes/clients/client/tipos-entrada-Respuesta.model";
import {
  APP_FORMATOS_FECHA,
  AppDateAdapter,
} from "@sharedV11/classes/dataAdapter/date-format.adapter";
import { CifNieValidator } from "@sharedV11/core/cif-validator";
import { AlertService } from "@sharedV11/services/alerts/alert/alert.service";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { ApiClientesService } from "@sharedV11/services/components/client/api-clientes.service";
import { ClientService } from "@sharedV11/services/components/client/client.service";
import { EditClientService } from "@sharedV11/services/components/edit_client/edit-client.service";
import { MaestrasService } from "@sharedV11/services/core/maestras.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { DualListComponent } from "angular-dual-listbox";
import moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Translator } from "src/app/shared/services/translator/translator.service";
import { ActivarClienteComponent } from "../activar-cliente/activar-cliente.component";
import { GruposTarifasService } from "@sharedV11/services/components/grupos-tarifas/grupos-tarifas.service";
import { getLocale } from "@sharedV11/utils/factories";
import { DatosLista } from "@sharedV11/services/api/connection/conectar-api.interface";
import { TableInteractiveComponent } from "@sharedV11/components/tables/table-interactive/table-interactive.component";
import { InputFilterComponent } from "src/app/shared/components/input-filter/input-filter.component";

//import { detectChanges } from '@angular/core/src/render3';

interface ValueSelectorField {
  name: string;
  id: string;
}

export class clientePlantilla {
  Id: string = "";
  Nombre: string = "";
  PrimerApellido: string = "";
  SegundoApellido: string = "";
  Email: string = "";
  Localidad: string = "";
  Provincia: string = "";
}

const INT32_MAX = 2147483647;
const INT32_MIN = -2147483648;

export function CodigoClienteInt32Validator(control: AbstractControl): { [key: string]: any } | null {
  if (!control || control.value === null || control.value === undefined || control.value === '') {
    return null;
  }
  const n = Number(control.value);
  if (Number.isNaN(n)) return null;
  if (n > INT32_MAX || n < INT32_MIN) {
    return { codigoClienteFueraDeRango: true };
  }
  return null;
}

export function ClientePadreValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control || !control.parent) {
    return null;
  }
  const tieneClientePadre = control.parent.get('TieneClientePadre').value;
  const clientePadreId = control.value;
  if (tieneClientePadre && (!clientePadreId || String(clientePadreId).trim() === '')) {
    return { 'clientePadreRequerido': true };
  }
  return null;
}

@Component({
  selector: "edit-client",
  templateUrl: "./edit-client.component.html",
  styleUrls: ["./edit-client.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_FORMATOS_FECHA,
    },
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class EditClientComponent implements OnInit {
  loading = true;
  private ngUnsubscribe = new Subject();
  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;

  @ViewChild("ti_limite_credito_cliente")
	ti_limite_credito_cliente: TableInteractiveComponent;

  editorRegistroForm: FormGroup;
  client: Cliente;
  clientBackup: Cliente;

  private reloadValuesInputsFilter = {};
  private toggleActiveInputFilter = {};

  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  activado: boolean;
  permision = {};

  idCliente: number;

  formaPago: ValueSelectorField[];
  pais: ValueSelectorField[];
  tipoCliente: ValueSelectorField[];
  zonaComercial: ValueSelectorField[];
  grupoCliente: ValueSelectorField[];

  translation;

  dataSourceContactos: MatTableDataSource<Contacto>;
  columnsToDisplayContacto: string[];
  listaContactos: Contacto[];
  ContactosFormGroup: any[];

  tiposTipoEntradaTallerAsignadas: Array<TipoEntrada> = [];
  tiposTipoEntradaTallerSinAsignar: Array<TipoEntrada> = [];
  tiposTiposEntradaAPI: TiposEntrada_Respuesta;
  tiposTipoEntrada: Array<TipoEntrada>;

  tiposTipoPromocionTallerAsignadas: Array<any> = [];
  tiposTipoPromocionRecintoSinAsignar: Array<any> = [];
  tiposTiposPromocionAPI: any;
  tiposTipoPromocion: Array<any>;

  tiposTipoAbonadoTallerAsignados: Array<any> = [];
  tiposTipoAbonadoRecintoSinAsignar: Array<any> = [];
  tiposTiposAbonadoAPI: any;
  tiposTipoAbonado: Array<any> = [];

  dataSourceCliente: MatTableDataSource<clientePlantilla>;
  listaClientes: clientePlantilla[];
  clientePlantilla: clientePlantilla;
  clienteFormGroup: FormArray = this.formBuilder.array([]);
  tablavalida: boolean;
  editando: boolean = false;
  idClienteEnEdicion: string;
  @ViewChild(MatTable) entradastable: MatTable<any>;

  @ViewChildren(InputFilterComponent)
  private inputFilterCmps: QueryList<InputFilterComponent>;
  columnsToDisplayTarifaEntrada: string[];
  listaIdiomas: any;
  listaPaises: any[];
  listaFormasPago: any;
  listaGruposClientes: any;
  listaZonaComercial: any;
  listaTiposClientes: any;
  listaCustomerId: any[] = [];
  customerIdListaResuelta = false;
  customerIdEsSelect: boolean = false;
  RegistrarModificar: string;
  listaCanales: any;
  permisoFormulario: boolean = true;
  permisobtnNuevo: boolean = true;
  permisobtnGuardar: boolean = true;
  permisobtnEliminar: boolean = false;
  permisobtnDuplicar: boolean = false;
  submitAttempted = false;
  VentaInternet: boolean = false;
  VentaAPI: boolean = false;
  estadebaja: string;
  url: any;
  duplicando: boolean;
  detalleCliente;

  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  tipoCentros: any[] = [];
  //centros

  //grupos tarifas
	gruposTarifasSinAsignar = [];
	gruposTarifasAsignados = [];


  // procedencia
  procedenciasSinAsignar = [];
  procedenciasAsignadas = [];
  
  // Tipo operador
  tiposOperadorSinAsignar = [];
  tiposOperadorAsignados = [];

  // tipos de turismo
  tiposTurismoSinAsignar = [];
  tiposTurismoAsignados = [];

  //Mercado
  idiomasMercado: DatosLista[] = [];
  tiposMercado: DatosLista[] = [];

  //Cliente padre
  clientesPadreList = [];

  constructor(
    private servicioAPI: ConectarApiService,
    private clientesAPI: ApiClientesService,
    private clientService: ClientService,
    private maestras: MaestrasService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private alertaServicio: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private translator: Translator,
    private _cds: ChangeDetectorRef,
    private panelService: PanelService,
    private editClientService: EditClientService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private gsCentros: GlobalServicCentros,
    private gruposTarifasService: GruposTarifasService
  ) {
    this.url = this.route.url;
  }

  async ngOnInit() {
    this.loadCentros();
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };

    this.tablavalida = true;
    this.clientePlantilla = {
      Id: "",
      Nombre: "",
      PrimerApellido: "",
      SegundoApellido: "",
      Email: "",
      Localidad: "",
      Provincia: "",
    };
    this.checkPermission();

    this.columnsToDisplayContacto = [
      "Acciones",
      "Nombre",
      "PrimerApellido",
      "SegundoApellido",
      "Email",
      "Localidad",
      "Provincia",
    ];

    this.generateFormGroup();
    this.loadData();
    this.panelService.setSaveActive(true);
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  callbacksInputFilter(event: any, inputName: string) {
    console.log({
      action: 'callbacksInputFilter',
      event,
    })
    this.reloadValuesInputsFilter[inputName] = event.methods.setManualValueForm;
    this.toggleActiveInputFilter[inputName] = event.methods.toggleActiveForm;
  }

  callReloadValuesInputFilter() {
    Object.keys(this.reloadValuesInputsFilter).forEach(key => {
      this.reloadValuesInputsFilter[key](this.client[key] ?? '');
    });
  }

  toggleActiveFormInputFilter(inputName: string, active: boolean) {
    if (this.toggleActiveInputFilter[inputName]) {
      this.toggleActiveInputFilter[inputName](active);
    }
  }

  manageForm(pkId, mode) {
    this.submitAttempted = false;
    //this.changeStatusClientCode(true)
    console.log({
      action: "manageForm",
      pkId: pkId,
      mode: mode
    });

    (<HTMLInputElement>document.getElementById("codigoCliente")).readOnly =
      false;
    if (mode == "I") {
      this.detalleCliente = null;
      this.client = this.editorRegistroForm.value;
      this.loading = false;

      // centros: limpar asignados para não herdar de sessão anterior
      this.centrosAsignados = [];
      this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();

      // entradas / promociones / abonados
      this.tiposTipoEntradaTallerAsignadas = [];
      this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
      this.tiposTipoPromocionTallerAsignadas = [];
      this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
      this.tiposTipoAbonadoTallerAsignados = [];
      this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();

      //Dual List Values
      this.gruposTarifasSinAsignar = this.gruposTarifasService.filtrarGruposTarifas();
      this.gruposTarifasAsignados = [];
      
      this.procedenciasAsignadas = [];

      this.tiposOperadorAsignados = [];

      this.tiposTurismoAsignados = [];

      this.editorRegistroForm.controls["bDeBajaInternet"].setValue(true);
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let todaystr = yyyy + "/" + mm + "/" + dd;
      this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue(
        todaystr
      );
    } else if (mode == "U") {
      (<HTMLInputElement>document.getElementById("codigoCliente")).readOnly =
        true;
    }
    this.valuedChanged();
    this.panelService.setSaveActive(true);
    if (pkId) {
      this.findClient(pkId);
    }
  }

  changeStatusClientCode(flag) {
    if (flag) this.f["Codigo"].enable();
    else this.f["Codigo"].disable();
  }

  save() {
    this.loading = false;
    this.panelService.setDiscardChanges(true);

    this.panelService.setSavePanel(null);
  }
  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }
  discard() {
    this.submitAttempted = false;
    //this.changeStatusClientCode(true)
    const clientToReset = this.clientBackup ? this.clientBackup : this.client;
    this.changeValueFormReset(clientToReset);
    //this.changeStatusClientCode(false)
  }
  submit() {
    this.submitAttempted = true;
    let flagValidContacts = true;
    this.editorRegistroForm.markAllAsTouched();
    this.clienteFormGroup.markAllAsTouched();
    // this.clienteFormGroup.controls[0].markAllAsTouched();
    this.clienteFormGroup.controls.map((contact) => {
      contact.markAllAsTouched();
      if (!contact.valid) {
        flagValidContacts = false;
      }
    });

    //this.manageApi(this.mode);
    // let client:Cliente=this.editorRegistroForm.value;
    if (this.editorRegistroForm.valid && flagValidContacts) {
      this.manageApi(this.mode);
    } else {
      if (this.editorRegistroForm.controls["Codigo"].errors?.codigoClienteFueraDeRango)
        this.snackvar_service.openSnackBar(
          this.translation.CodigoClienteMaxInt32,
          "",
          "red-snackbar"
        );
      if (!this.editorRegistroForm.controls["FormaDePago"].valid)
        this.snackvar_service.openSnackBar(
          this.translation.especificar_forma_pago || this.translation.CampoRequerido,
          "",
          "red-snackbar"
        );
      if (!this.editorRegistroForm.controls["GrupoCliente"].valid)
        this.snackvar_service.openSnackBar(
          (this.translation.GrupoCliente || "Grupo cliente") + ": " + this.translation.CampoRequerido,
          "",
          "red-snackbar"
        );
      if (!this.editorRegistroForm.controls["ZonaComercial"].valid)
        this.snackvar_service.openSnackBar(
          (this.translation.ZonaComercial || "Zona comercial") + ": " + this.translation.CampoRequerido,
          "",
          "red-snackbar"
        );
      if (!this.editorRegistroForm.controls["TipoCliente"].valid)
        this.snackvar_service.openSnackBar(
          this.translation.especificar_tipo_cliente || this.translation.CampoRequerido,
          "",
          "red-snackbar"
        );
      if (this.editorRegistroForm.controls["NombreCliente"].invalid)
        this.snackvar_service.openSnackBar(
          (this.translation.NombreCliente || "Nombre cliente") + ": " + this.translation.CampoRequerido,
          "",
          "red-snackbar"
        );
      if (this.editorRegistroForm.controls["ClientePadreId"]?.invalid && this.editorRegistroForm.controls["TieneClientePadre"].value)
        this.snackvar_service.openSnackBar(
          (this.translation.ClientePrincipal || "Cliente principal") + ": " + this.translation.CampoRequerido,
          "",
          "red-snackbar"
        );
    }
  }

  manageApi(mode) {
    //this.insertDataInObj();
    //this.changeStatusClientCode(true)
    this.loading = true;
    switch (mode) {
      case "I":
        //insert
        //this.f["Codigo"].setValue("");
        this.RegistrarModificar = "0";
        this.newGuardar();
        break;
      case "U":
        this.RegistrarModificar = "1";
        //update
        this.newGuardar();

        break;
      case "D":
        //duplicate
        this.RegistrarModificar = "0";
        // this.f["Codigo"].setValue("");
        this.newGuardar();

        break;

      default:
        break;
    }
    //this.changeStatusClientCode(false)
  }

  insUpdUsuario(client) {
    this.editClientService
      .insUpdClienteNew(client)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.save();
          this.destroy();
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  /** Reaplica IDs do cliente carregado quando `*SinAsignar` já veio do MS (evita race com loadData). */
  private applyProcedenciasAsignadasFromDetalle(): void {
    const ca = this.detalleCliente?.ClienteAdicional;
    if (!ca || !this.procedenciasSinAsignar?.length) {
      return;
    }
    this.procedenciasAsignadas = this.servicioAPI.getArrDatosAsignados(
      ca.ListaDatosClienteProcedenciaIds,
      this.procedenciasSinAsignar,
      "pkid"
    );
  }

  private applyOperadorAsignadosFromDetalle(): void {
    const ca = this.detalleCliente?.ClienteAdicional;
    if (!ca || !this.tiposOperadorSinAsignar?.length) {
      return;
    }
    this.tiposOperadorAsignados = this.servicioAPI.getArrDatosAsignados(
      ca.ListaDatosClienteOperadorIds,
      this.tiposOperadorSinAsignar,
      "pkid"
    );
  }

  private applyTurismoAsignadosFromDetalle(): void {
    const ca = this.detalleCliente?.ClienteAdicional;
    if (!ca || !this.tiposTurismoSinAsignar?.length) {
      return;
    }
    this.tiposTurismoAsignados = this.servicioAPI.getArrDatosAsignados(
      ca.ListaDatosClienteTurismoIds,
      this.tiposTurismoSinAsignar,
      "pkid"
    );
  }

  findClient(pkId) {
    this.clientesAPI.getClientDetail(pkId).subscribe(
      (res) => { 
        this.detalleCliente = res;
        this.procedenciasAsignadas = [];
        this.tiposOperadorAsignados = [];
        this.tiposTurismoAsignados = [];

        const clientInfo = res?.Cliente;
        // TODO::: actualiza los datos del form con lo que viene aqui (faltan algunos campos en la peticion)
        // TODO::: parsear strings a bool para los checks
        this.changeValueForm(res);
        this.client = this.editorRegistroForm.value;
        this.client["CentrosIds"] = clientInfo?.CentrosIds;
        this.client['GruposTarifas'] = clientInfo?.GruposTarifas;

        this.valuedChanged();

        this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
        this.centrosAsignados = this.gsCentros.daTiposCentros(this.client);

         //grupos tarifas
        this.gruposTarifasSinAsignar = this.gruposTarifasService.filtrarGruposTarifas();
        this.gruposTarifasAsignados = this.gruposTarifasService.getArrGruposTarifasAsignadas(clientInfo?.GruposTarifas);

        this.applyProcedenciasAsignadasFromDetalle();
        this.applyOperadorAsignadosFromDetalle();
        this.applyTurismoAsignadosFromDetalle();

        this.loading = false;
        console.log({
          client: this.client
        });

        setTimeout(() => {
          const sync = this.reloadValuesInputsFilter?.["CustomerId"];
          const cid = this.client?.["CustomerId"];
          if (sync && cid !== undefined && cid !== null && cid !== "") {
            sync(cid);
          }
        }, 0);
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        this.destroy();
      }
    );
  }

  findAndCompleteSubclient(pkId) {
    this.loading = true;
    this.clientesAPI.getClientDetail(pkId).subscribe(
      (res) => { 
        console.log({
          tempClient: res
        })
        this.clientBackup = this.client;

        this.detalleCliente = res;
        this.procedenciasAsignadas = [];
        this.tiposOperadorAsignados = [];
        this.tiposTurismoAsignados = [];

        const clientInfo = res?.Cliente;
        //res.DatosComunes.CodigoCliente = "";
        res.DatosComunes.CodigoCliente = this.editorRegistroForm.value.Codigo;
        res.DatosComunes.CodigoClientePadre = this.editorRegistroForm.value.ClientePadreId;
        this.changeValueForm(res);
        this.client = this.editorRegistroForm.value;
        this.client["CentrosIds"] = clientInfo?.CentrosIds;
        this.client['GruposTarifas'] = clientInfo?.GruposTarifas;

        if (this.reloadValuesInputsFilter) {
          this.callReloadValuesInputFilter();
        }

        console.log({
          clientAftercomplete: this.client
        })

        this.valuedChanged();

        this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
        this.centrosAsignados = this.gsCentros.daTiposCentros(clientInfo);

         //grupos tarifas
        this.gruposTarifasSinAsignar = this.gruposTarifasService.filtrarGruposTarifas();
        this.gruposTarifasAsignados = this.gruposTarifasService.getArrGruposTarifasAsignadas(clientInfo?.GruposTarifas);

        console.log({
          resCliente: res
        })
        this.applyProcedenciasAsignadasFromDetalle();
        this.applyOperadorAsignadosFromDetalle();
        this.applyTurismoAsignadosFromDetalle();

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  valuedChanged() {
    this.editorRegistroForm.valueChanges.subscribe((value) => {
      if (this.client != null) {
        this.panelService.setDiscardChanges(false);
        if (JSON.stringify(value) === JSON.stringify(this.client)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }
  async loadData() {
    await this.CargarDatosTiposEntradas();
    await this.CargarDatosTiposPromociones();
    await this.CargarDatosTiposAbonados();

    /*   await this.servicioAPI.ObtenerCustomanCanales().then(res => {
      });
      await this.servicioAPI.ObtenerCustomanGrupoTipoAbonado().then(res => {
      }); */
    

    this.servicioAPI.traerCodClientes().subscribe((data) => {
      console.log({
        action: "traer clientes con codigo",
        data: data
      })
      const hasData = data?.DatosListas && data?.DatosListas.length > 0;
      this.clientesPadreList = hasData ? data?.DatosListas : [];
    });
    
    this.servicioAPI.getDatosListasMS({
      nombreTabla: 'idiomas'
    }).subscribe((data) => {
      const hasData = data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0;
      this.idiomasMercado = hasData ? data?.datosResult?.datosListas : [];
    });

    this.servicioAPI.getDatosListasMS({
      nombreTabla: 'datosclientemercado'
    }).subscribe((data) => {
      const hasData = data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0;
      this.tiposMercado = hasData ? data?.datosResult?.datosListas : [];
    });

    this.servicioAPI.getDatosListasMS({
      nombreTabla: 'datosclienteprocedencia'
    }).subscribe((data) => {
      const hasData = data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0;
      this.procedenciasSinAsignar = hasData ? data?.datosResult?.datosListas : [];
      this.applyProcedenciasAsignadasFromDetalle();
      this._cds.detectChanges();
    });

    this.servicioAPI.getDatosListasMS({
      nombreTabla: 'datosclienteoperador'
    }).subscribe((data) => {
      const hasData = data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0;
      this.tiposOperadorSinAsignar = hasData ? data?.datosResult?.datosListas : [];
      this.applyOperadorAsignadosFromDetalle();
      this._cds.detectChanges();
    });

    this.servicioAPI.getDatosListasMS({
      nombreTabla: 'datosclienteturismo'
    }).subscribe((data) => {
      const hasData = data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0;
      this.tiposTurismoSinAsignar = hasData ? data?.datosResult?.datosListas : [];
      this.applyTurismoAsignadosFromDetalle();
      this._cds.detectChanges();
    });


    this.servicioAPI.traerGruposTarifas().subscribe(
      (data) => {
        const hasData = data?.DatosListas && data?.DatosListas.length > 0;
        this.gruposTarifasService.setGruposTarifas(
          hasData ? data?.DatosListas : []
        );
      },
      error => {
        this.httpErrorService.identificarErrores(error);
      }
    )

    this.listaPaises = this.maestras.getMasters("paises");
    await this.servicioAPI.getZonaComercial().subscribe(
      (res) => {
        this.listaZonaComercial = res?.DatosListas ?? [];
        if (!this.listaZonaComercial.length) {
          this.editorRegistroForm.get("ZonaComercial")?.clearValidators();
          this.editorRegistroForm.get("ZonaComercial")?.setValue("", { emitEvent: false });
          this.editorRegistroForm.get("ZonaComercial")?.updateValueAndValidity();
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        this.listaZonaComercial = [];
      }
    );

    await this.servicioAPI.getFormasPagoAsync().then(
      (res) => {
        // pkId - Denominacion
        if (res.DatosResult)
          this.listaFormasPago = res.DatosResult.customanFormaPago;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    await this.servicioAPI.getGruposClienteAsync().then(
      (res) => {
        // ERROR: No se han encontrado datos
        if (res.DatosResult)
          this.listaGruposClientes = res.DatosResult.customanGrupoCliente;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    await this.servicioAPI.getTiposClienteAsync().then(
      (res) => {
        // pkId - Nombre
        if (res.DatosResult)
          this.listaTiposClientes = res.DatosResult.tipoClientes;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    await this.servicioAPI.ObtenerCustomanCanales().then(
      (res) => {
        if (res.DatosResult)
          this.listaCanales = res.DatosResult.Lista.filter(
            (f) => f.Seleccionable == "1"
          );
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    await this.servicioAPI.getIdiomasAsync(null, null, "1").then(
      (res) => {
        if (res.DatosResult) this.listaIdiomas = res.DatosResult.ListaIdiomas;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );

    this.servicioAPI.TraerDatosListasAsync("txclienteId").subscribe(
      (res) => {
        const hasData = res?.DatosListas?.length > 0;
        this.listaCustomerId = hasData ? res.DatosListas : [];
        this.customerIdEsSelect = hasData;
        this.customerIdListaResuelta = true;
        this._cds.detectChanges();
        setTimeout(() => {
          const sync = this.reloadValuesInputsFilter?.["CustomerId"];
          const cid = this.client?.["CustomerId"];
          if (sync && cid !== undefined && cid !== null && cid !== "") {
            sync(cid);
          }
        }, 0);
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        this.listaCustomerId = [];
        this.customerIdEsSelect = false;
        this.customerIdListaResuelta = true;
      }
    );

    this.manageForm(this.pkId, this.mode);
  }
  get f() {
    return this.editorRegistroForm.controls;
  }

  goToShowClientes(): void {
    this.router.navigate(["Cliente"], { relativeTo: this.route.parent });
  }

  esbaja() {
    this.estadebaja = this.editorRegistroForm.value.bDeBaja;
  }

  deAlta(): void {
    this.clientService.altaBajaCliente(this.pkId).subscribe(
      (data) => {
        this.alertaServicio.success(data.Avisos);
        this.loadClientData(this.pkId);
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  deBaja(): void {
    if (!this.estadebaja) {
      const dialogRef = this.dialog.open(ActivarClienteComponent, {
        width: "600px",
        height: "250px",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.clientService.altaBajaCliente(this.pkId, result).subscribe(
            (data) => {
              this.alertaServicio.success(data.Avisos);
              this.loadData();
              //this.loadClientData(this.pkId);
            },
            (error) => {
              this.httpErrorService.identificarErrores(error);
            }
          );
        }
      });
    } else {
      if (confirm(this.translation.activarusuario)) {
        this.clientService
          .altaBajaCliente(this.pkId, null)
          .subscribe((data) => {
            this.alertaServicio.success(data.Avisos);
            this.loadData();
          });
      }
    }
  }

  guardar(): void {
    if (this.editorRegistroForm.invalid) {
      this.markFormGroupTouched(this.editorRegistroForm);
      this.alertaServicio.error(this.translation.FaltanCamposObligatorios);
    } else {
      this.syncInputFilterHiddensToForm();
      this.clientService
        .addClient(this.editorRegistroForm.getRawValue(), this.pkId)
        .subscribe(
          (data) => {
            this.alertaServicio.success(data.Avisos);
          },
          (error) => {
            this.httpErrorService.identificarErrores(error);
          }
        );
    }
  }

  private loadClientData(id: string): void {
    this.clientService.getClientById(id).subscribe(
      (data) => {
        this.loading = false;
        const temp = ClienteMapper.convertToIU(data);
        this.activado = !temp.debaja;
        this.editorRegistroForm.patchValue(temp);
      },
      (err) => {
        this.alertaServicio.error(err);
      }
    );
  }

  generateFormGroup() {
    this.editorRegistroForm = this.formBuilder.group({
      // campos antiguos
      informacion_personal: this.formBuilder.group({
        tipo_documento: [null],
        num_documento: [null],
        nombre: [null],
        imprimir: [false],
        nombre_comercial: [""],
        primer_apellido: [""],
        segundo_apellido: [""],
      }),
      informacion_contacto: this.formBuilder.group({
        email: [null],
        email_2: [""],
        prefijo_tlf: [""],
        tlf: [""],
        tlf_2: [""],
        domicilio: [""],
        localidad: [""],
        codigo_postal: ["", [Validators.maxLength(5)]],
        provincia: [""],
        pais: [""],
      }),
      detalles_cuenta: this.formBuilder.group({
        forma_pago: [null],
        grupo_cliente: [null],
        zona_comercial: [null],
        tipo_cliente: [null],
      }),

      // Campos Nuevos (CodigoCliente na API é Int32: máx. 2.147.483.647)
      Codigo: ["", [CodigoClienteInt32Validator]],
      TipoDocumento: [""],
      NumDocumento: [""],
      NombreComercial: [""],
      ImprimirEnTicket: [false],
      NombreCliente: ["", [Validators.required]],
      //PrimerApellido: [''],
      //SegundoApellido: [''],
      CorreoElectronico: [""],
      CorreoElectronico2: [""],
      PrefijoInternacional: [""],
      Telefono1: [""],
      Telefono2: [""],
      Movil: [""],
      Domicilio: [""],
      Localidad: [""],
      Provincia: [""],
      CodigoPostal: [""],
      Pais: [""],
      Nacionalidad: [""],
      FormaDePago: ["", [Validators.required]],
      GrupoCliente: ["", [Validators.required]],
      ZonaComercial: ["", [Validators.required]],
      TipoCliente: [""],
      bDeBaja: [false],
      FechaDeBaja: [""],
      FechaDeAltaTaquilla: [""],
      DescuentoTaquilla: [false],
      TipoDescuentoTaquilla: [""],
      ImporteDescuentoTaquilla: [0],
      RedondearPrecioTaquilla: [false],
      TicketSinDescuentoTaquilla: [false],
      VentaEnInternet: [""],
      VentaAPI: [""],
      FechaDeAltaInternet: [""],
      Usuario: [""],
      DescuentoInternet: [false],
      TipoDescuentoInternet: [""],
      ImporteDescuentoInternet: [0],
      RedondearPrecioInternet: [false],
      TicketSinDescuentoInternet: [false],
      bDeBajaInternet: [false],
      FechaDeBajaInternet: [""],
      TipoDocumentoFacturacion: [""],
      NumDocumentoFacturacion: [""],
      RazonSocial: [""],
      NombreFacturacion: [""],
      PrimerApellidoFacturacion: [""],
      SegundoApellidoFacturacion: [""],
      DomicilioFacturacion: [""],
      LocalidadFacturacion: [""],
      ProvinciaFacturacion: [""],
      CodigoPostalFacturacion: [""],
      PaisFacturacion: [""],
      PaisCodigo: [""],
      Persona: [""],
      Direccion: [""],
      Lugar: [""],
      Dias: [""],
      clienteFormGroupArray: this.clienteFormGroup,

      // Campos Nuevos
      Entradas: [""],
      Promociones: [""],
      Abonados: [""],
      Canales: [""],

      // Mas Campos Nuevos
      Observaciones: [""],
      ObsAdvertencia: [""],
      CodIdiomaVisita: [""],
      IdiomaVisita: [""],
      CodIdiomaDocumento: [""],
      IdiomaDocumento: [""],

      /* Mercado Form Values */
      ClienteCargo: [""],
      ClienteIdiomaMercado: [""],
      ClienteTipoMercado: [""],

      //Límite de crédito
      TieneCredito: [false],
      TieneClientePadre: [false],

      //ClientePadreId será obligatorio si TieneClientePadre es true y opcional si es false
      ClientePadreId: ["", [ClientePadreValidator]],

      CustomerId: ["", [Validators.maxLength(50)]],
    });

    this.editorRegistroForm
      .get("informacion_personal")
      .get("tipo_documento")
      .valueChanges.subscribe((tipo_documento) => {
        const numero_documento_control = this.editorRegistroForm
          .get("informacion_personal")
          .get("num_documento");
        if (tipo_documento === "NIF") {
          numero_documento_control.clearValidators();
          numero_documento_control.setValidators([
            Validators.required,
            CifNieValidator,
          ]);
        } else {
          numero_documento_control.clearValidators();
          numero_documento_control.setValidators([Validators.required]);
        }
        numero_documento_control.updateValueAndValidity();
      });

    this.editorRegistroForm.get('TieneClientePadre').valueChanges.subscribe((value) => {
      if (!value) {
        if (this.reloadValuesInputsFilter)
          if (this.reloadValuesInputsFilter['ClientePadreId']) 
            this.reloadValuesInputsFilter['ClientePadreId']('');
        
        // TODO validar existencia si es necesario borrar
        this.editorRegistroForm
          .get("ClientePadreId")
          .setValue("");

        if (this.client) {
          this.client["ClientePadreId"] = "";
        }
      }
      else
        console.log('TieneClientePadre is true, no action on ClientePadreId');

    });

    this.editorRegistroForm.get('ClientePadreId').valueChanges.subscribe((value) => {
      if (this.toggleActiveFormInputFilter) {
        this.toggleActiveFormInputFilter('TipoCliente', value ? false : true);
      }
    });
  }

  changeValueForm(res) {
    //if (!this.duplicando)

    this.editorRegistroForm.controls["TieneClientePadre"].setValue(
      res?.DatosComunes?.CodigoClientePadre ? true : false
    );

    this.editorRegistroForm.controls["ClientePadreId"].setValue(
      res?.DatosComunes?.CodigoClientePadre ?? ""
    );

    this.editorRegistroForm.controls["Codigo"].setValue(
      res.DatosComunes.CodigoCliente
    );

    this.editorRegistroForm.controls["TipoDocumento"].setValue(
      res.DatosComunes.TipoDocumento
    );
    this.editorRegistroForm.controls["NumDocumento"].setValue(
      res.DatosComunes.CIFoDNI
    );
    this.editorRegistroForm.controls["NombreComercial"].setValue(
      res.Cliente.NombreComercial
    );
    this.editorRegistroForm.controls["NombreCliente"].setValue(
      res.DatosComunes.NombreCliente
    );
    //this.editorRegistroForm.controls['PrimerApellido'].setValue(res.DatosComunes.PrimerApellido);
    //this.editorRegistroForm.controls['SegundoApellido'].setValue(res.DatosComunes.SegundoApellido);
    this.editorRegistroForm.controls["CorreoElectronico"].setValue(
      res.Cliente.EMail
    );
    this.editorRegistroForm.controls["CorreoElectronico2"].setValue(
      res.Cliente.EMail2
    );
    this.editorRegistroForm.controls["PrefijoInternacional"].setValue(
      res.DatosComunes.PrefijoInternacional
    );
    this.editorRegistroForm.controls["Telefono1"].setValue(
      res.DatosComunes.Telefono
    );
    this.editorRegistroForm.controls["Telefono2"].setValue(
      res.Cliente.Telefono2
    );
    this.editorRegistroForm.controls["Movil"].setValue(res.DatosComunes.Movil);
    this.editorRegistroForm.controls["Domicilio"].setValue(
      res.DatosComunes.Domicilio
    );
    this.editorRegistroForm.controls["Localidad"].setValue(
      res.DatosComunes.Localidad
    );
    this.editorRegistroForm.controls["Provincia"].setValue(
      res.DatosComunes.Provincia
    );
    this.editorRegistroForm.controls["CodigoPostal"].setValue(
      res.DatosComunes.CP
    );
    this.editorRegistroForm.controls["Pais"].setValue(res.DatosComunes.Pais);
    this.editorRegistroForm.controls["Nacionalidad"].setValue(
      res.DatosComunes.Nacionalidad
    );
    this.editorRegistroForm.controls["FormaDePago"].setValue(
      res.Cliente.TipoPagoId
    );
    this.editorRegistroForm.controls["GrupoCliente"].setValue(
      res.Cliente.CodigoGrupos
    );
    this.editorRegistroForm.controls["ZonaComercial"].setValue(
      res.Cliente.CodigoZonaComercial
    );
    this.editorRegistroForm.controls["TipoCliente"].setValue(
      res.Cliente.TipoClienteId == "0" ? "" : res.Cliente.TipoClienteId
    );
    this.editorRegistroForm.controls["bDeBaja"].setValue(
      res.Cliente.DeBaja == "1" ? true : false
    );
    this.editorRegistroForm.controls["FechaDeBaja"].setValue(
      this.aFecha(res.Cliente.FechaBaja)
    );
    //
    this.editorRegistroForm.controls["ImprimirEnTicket"].setValue(
      res.DatosComunes.ImprimirEnTicket == "1" ? true : false
    );

    // Venta en taquilla
    this.editorRegistroForm.controls["FechaDeAltaTaquilla"].setValue(
      this.aFecha(res.Cliente.FechaAlta)
    );
    this.editorRegistroForm.controls["DescuentoTaquilla"].setValue(
      res.Cliente.TieneDescuento == "1" ? true : false
    );
    this.editorRegistroForm.controls["TipoDescuentoTaquilla"].setValue(
      res.Cliente.TipoDescuento
    );
    this.editorRegistroForm.controls["ImporteDescuentoTaquilla"].setValue(
      res.Cliente.CantidadDescuento
    );
    this.editorRegistroForm.controls["RedondearPrecioTaquilla"].setValue(
      res.Cliente.RedondeoPrecios == "1" ? true : false
    );
    this.editorRegistroForm.controls["TicketSinDescuentoTaquilla"].setValue(
      res.Cliente.TicketSinDescuento == "1" ? true : false
    );
    this.editorRegistroForm.controls["VentaEnInternet"].setValue(
      res.ClienteInternet.VentaEnInternet == "1" ? true : false
    );
    this.editorRegistroForm.controls["VentaAPI"].setValue(
      res.ClienteAdicional.VentaAPI == "1" ? true : false
    );
    this.editorRegistroForm.controls["FechaDeAltaInternet"].setValue(
      this.aFecha(res.ClienteInternet.FechaAlta)
    );
    /** Duplicar (D): igual que alta (I) — usuario internet vacío hasta que el usuario lo rellene (evita copiar CodigoCliente). */
    this.editorRegistroForm.controls["Usuario"].setValue(
      this.mode === "D" ? "" : res.ClienteInternet.Usuario
    );

    this.editorRegistroForm.controls["DescuentoInternet"].setValue(
      res.ClienteInternet.TieneDescuento == "1" ? true : false
    );
    this.editorRegistroForm.controls["TipoDescuentoInternet"].setValue(
      res.ClienteInternet.TipoDescuento
    );
    this.editorRegistroForm.controls["ImporteDescuentoInternet"].setValue(
      res.ClienteInternet.CantidadDescuento
    );
    this.editorRegistroForm.controls["RedondearPrecioInternet"].setValue(
      res.ClienteInternet.RedondeoPrecios == "1" ? true : false
    );
    this.editorRegistroForm.controls["TicketSinDescuentoInternet"].setValue(
      res.ClienteInternet.TicketSinDescuento == "1" ? true : false
    );
    this.editorRegistroForm.controls["bDeBajaInternet"].setValue(
      res.ClienteInternet.DeBaja == "1" ? true : false
    );
    this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue(
      this.aFecha(res.ClienteInternet.FechaBaja)
    );
    this.editorRegistroForm.controls["Observaciones"].setValue(
      res.ClienteInternet.Observaciones
    );
    this.editorRegistroForm.controls["ObsAdvertencia"].setValue(
      res.ClienteInternet.ObsAdvertencia
    );
    this.editorRegistroForm.controls["CodIdiomaVisita"].setValue(
      res.ClienteInternet.CodIdiomaVisita
    );
    this.editorRegistroForm.controls["CodIdiomaDocumento"].setValue(
      res.ClienteInternet.CodIdiomaDocumento
    );

    // Datos de facturacion (¿ClienteAdicional?)
    this.editorRegistroForm.controls["TipoDocumentoFacturacion"].setValue(
      res.ClienteAdicional.TipoDocumento
    );
    this.editorRegistroForm.controls["NumDocumentoFacturacion"].setValue(
      res.ClienteAdicional.NumeroDocumento
    );
    this.editorRegistroForm.controls["RazonSocial"].setValue(
      res.ClienteAdicional.NombreClienteFactura
    );
    this.editorRegistroForm.controls["NombreFacturacion"].setValue(
      res.ClienteAdicional.RazonSocial
    );
    this.editorRegistroForm.controls["PrimerApellidoFacturacion"].setValue(
      res.ClienteAdicional.PrimerApellido
    );
    this.editorRegistroForm.controls["SegundoApellidoFacturacion"].setValue(
      res.ClienteAdicional.SegundoApellido
    );
    this.editorRegistroForm.controls["DomicilioFacturacion"].setValue(
      res.ClienteAdicional.Domicilio
    );
    this.editorRegistroForm.controls["LocalidadFacturacion"].setValue(
      res.ClienteAdicional.Localidad
    );
    this.editorRegistroForm.controls["ProvinciaFacturacion"].setValue(
      res.ClienteAdicional.Provincia
    );
    this.editorRegistroForm.controls["CodigoPostalFacturacion"].setValue(
      res.ClienteAdicional.CodigoPostal
    );
    this.editorRegistroForm.controls["PaisFacturacion"].setValue(
      res.ClienteAdicional.Pais
    );
    this.editorRegistroForm.controls["PaisCodigo"].setValue(
      res.ClienteAdicional.PaisCodigo
    );

    /* 
      ClienteCargo: [""],
      ClienteIdiomaMercado: [""],
      ClienteTipoMercado: [""]
    
    */
    
    this.editorRegistroForm.controls["ClienteCargo"].setValue(
      res?.ClienteAdicional?.Cargo ?? ""
    );
    this.editorRegistroForm.controls["ClienteIdiomaMercado"].setValue(
      res?.ClienteAdicional?.IdiomaAdicional ?? ""
    );
    this.editorRegistroForm.controls["ClienteTipoMercado"].setValue(
      res?.ClienteAdicional?.DatosClienteMercadoId ? +res.ClienteAdicional.DatosClienteMercadoId : ''
    );

    this.editorRegistroForm.controls["CustomerId"].setValue(
      res?.DatosComunes?.CustomerId ?? ""
    );

    // Datos de pago (xxxCobro)
    this.editorRegistroForm.controls["Persona"].setValue(
      res.DatosComunes.PersonaCobro
    );
    this.editorRegistroForm.controls["Direccion"].setValue(
      res.DatosComunes.DireccionCobro
    );
    this.editorRegistroForm.controls["Lugar"].setValue(
      res.DatosComunes.LugarCobro
    );
    this.editorRegistroForm.controls["Dias"].setValue(
      this.aFecha(res.DatosComunes.DiaPago)
    );

    const TipoCliente = this.editorRegistroForm.get("TipoCliente");
    const VentaInternet = this.editorRegistroForm.get("VentaEnInternet");

    if (VentaInternet.value == true) {
      TipoCliente.clearValidators();
      TipoCliente.setValidators(Validators.required);
      TipoCliente.updateValueAndValidity();
    }

    this.esbaja();

    if (this.listaClientes === undefined) {
      this.listaClientes = [];
    }

    if (res.Cliente.Contactos.ListadoContacto) {
      res.Cliente.Contactos.ListadoContacto.forEach((contacto) => {
        let loadContacto = new FormGroup({
          Id: new FormControl(),
          Nombre: new FormControl(),
          PrimerApellido: new FormControl(),
          SegundoApellido: new FormControl(),
          Email: new FormControl(),
          Localidad: new FormControl(),
          Provincia: new FormControl(),
        });

        loadContacto.setValue({
          Id: contacto.pkId,
          Nombre: contacto.Nombre,
          PrimerApellido: contacto.Apellido1,
          SegundoApellido: contacto.Apellido2,
          Email: contacto.Email,
          Localidad: contacto.Localidad,
          Provincia: contacto.Provincia,
        });

        this.clienteFormGroup.push(loadContacto);
        this.listaClientes.push(new clientePlantilla()); //clientePlantilla formulario de entrada
        //this.actualizarclienteFormGroup()
        this.setDataSourceClientes();
      });
    }

    // Campos Nuevos (a la espera de que se incorporen al API)

    // antiguos
    /*
    this.editorRegistroForm.controls['Entradas'].setValue(res.Cliente.GruposEntradas);
    this.editorRegistroForm.controls['Promociones'].setValue(res.Cliente.GruposPromociones);
    this.editorRegistroForm.controls['Abonados'].setValue(res.Cliente.GruposAbonado);
    */
    this.idToList(res.Cliente.GruposEntradas, "Entradas");
    this.editorRegistroForm.controls["Entradas"].setValue(
      res.Cliente?.GruposEntradas ?? ""
    );
    this.idToList(res.Cliente.GruposPromociones, "Promociones");
    this.editorRegistroForm.controls["Promociones"].setValue(
      res.Cliente?.GruposPromociones ?? ""
    );
    this.idToList(res.Cliente.GruposAbonado, "Abonados");
    this.editorRegistroForm.controls["Abonados"].setValue(
      res.Cliente?.GruposAbonado ?? ""
    );

    this.editorRegistroForm.controls["Canales"].setValue(res.Cliente.Canales);

    // Mas campos nuevos
    this.editorRegistroForm.controls["Observaciones"].setValue(
      res.ClienteInternet.Observaciones
    );
    this.editorRegistroForm.controls["ObsAdvertencia"].setValue(
      res.ClienteInternet.ObsAdvertencia
    );
    this.editorRegistroForm.controls["CodIdiomaVisita"].setValue(
      res.ClienteInternet.CodIdiomaVisita
    );
    this.editorRegistroForm.controls["IdiomaVisita"].setValue(
      res.ClienteInternet.IdiomaVisita
    );
    this.editorRegistroForm.controls["CodIdiomaDocumento"].setValue(
      res.ClienteInternet.CodIdiomaDocumento
    );
    this.editorRegistroForm.controls["IdiomaDocumento"].setValue(
      res.ClienteInternet.IdiomaDocumento
    );

    this.editorRegistroForm.controls["TieneCredito"].setValue(
      res?.Cliente.TieneCredito == "1" ? true : false
    );

    this.getFechaBaja();
    this._cds.detectChanges();
  }

  changeValueFormReset(res) {
    //if (!this.duplicando)
    this.editorRegistroForm.controls["Codigo"].setValue(res.Codigo);
    //else
    //this.editorRegistroForm.controls['Codigo'].setValue("");

    this.editorRegistroForm.controls["TipoDocumento"].setValue(
      res.TipoDocumento
    );
    this.editorRegistroForm.controls["NumDocumento"].setValue(res.NumDocumento);
    this.editorRegistroForm.controls["NombreComercial"].setValue(
      res.NombreComercial
    );
    this.editorRegistroForm.controls["NombreCliente"].setValue(
      res.NombreCliente
    );
    //this.editorRegistroForm.controls['PrimerApellido'].setValue(res.PrimerApellido);
    //this.editorRegistroForm.controls['SegundoApellido'].setValue(res.SegundoApellido);
    this.editorRegistroForm.controls["CorreoElectronico"].setValue(
      res.CorreoElectronico
    );
    this.editorRegistroForm.controls["CorreoElectronico2"].setValue(
      res.CorreoElectronico2
    );
    this.editorRegistroForm.controls["PrefijoInternacional"].setValue(
      res.PrefijoInternacional
    );
    this.editorRegistroForm.controls["Telefono1"].setValue(res.Telefono1);
    this.editorRegistroForm.controls["Telefono2"].setValue(res.Telefono2);
    this.editorRegistroForm.controls["Movil"].setValue(res.Movil);
    this.editorRegistroForm.controls["Domicilio"].setValue(res.Domicilio);
    this.editorRegistroForm.controls["Localidad"].setValue(res.Localidad);
    this.editorRegistroForm.controls["Provincia"].setValue(res.Provincia);
    this.editorRegistroForm.controls["CodigoPostal"].setValue(res.CodigoPostal);
    this.editorRegistroForm.controls["Pais"].setValue(res.Pais);
    this.editorRegistroForm.controls["Nacionalidad"].setValue(res.Nacionalidad);
    this.editorRegistroForm.controls["FormaDePago"].setValue(res.FormaDePago);
    this.editorRegistroForm.controls["GrupoCliente"].setValue(res.GrupoCliente);
    this.editorRegistroForm.controls["ZonaComercial"].setValue(
      res.ZonaComercial
    );
    this.editorRegistroForm.controls["TipoCliente"].setValue(res.TipoCliente);
    this.editorRegistroForm.controls["bDeBaja"].setValue(res.bDeBaja);
    this.editorRegistroForm.controls["FechaDeBaja"].setValue(res.FechaDeBaja);
    //
    this.editorRegistroForm.controls["ImprimirEnTicket"].setValue(
      res.ImprimirEnTicket
    );

    // Venta en taquilla
    this.editorRegistroForm.controls["FechaDeAltaTaquilla"].setValue(
      res.FechaDeAltaTaquilla
    );
    this.editorRegistroForm.controls["DescuentoTaquilla"].setValue(
      res.DescuentoTaquilla
    );
    this.editorRegistroForm.controls["TipoDescuentoTaquilla"].setValue(
      res.TipoDescuentoTaquilla
    );
    this.editorRegistroForm.controls["ImporteDescuentoTaquilla"].setValue(
      res.ImporteDescuentoTaquilla
    );
    this.editorRegistroForm.controls["RedondearPrecioTaquilla"].setValue(
      res.RedondearPrecioTaquilla
    );
    this.editorRegistroForm.controls["TicketSinDescuentoTaquilla"].setValue(
      res.TicketSinDescuentoTaquilla
    );
    this.editorRegistroForm.controls["VentaEnInternet"].setValue(
      res.VentaEnInternet
    );
    this.editorRegistroForm.controls["VentaAPI"].setValue(
      res.VentaAPI
    );
    this.editorRegistroForm.controls["FechaDeAltaInternet"].setValue(
      res.FechaDeAltaInternet
    );
    this.editorRegistroForm.controls["Usuario"].setValue(
      this.mode === "D" ? "" : res.Usuario
    );

    this.editorRegistroForm.controls["DescuentoInternet"].setValue(
      res.DescuentoInternet
    );
    this.editorRegistroForm.controls["TipoDescuentoInternet"].setValue(
      res.TipoDescuentoInternet
    );
    this.editorRegistroForm.controls["ImporteDescuentoInternet"].setValue(
      res.ImporteDescuentoInternet
    );
    this.editorRegistroForm.controls["RedondearPrecioInternet"].setValue(
      res.RedondearPrecioInternet
    );
    this.editorRegistroForm.controls["TicketSinDescuentoInternet"].setValue(
      res.TicketSinDescuentoInternet
    );
    this.editorRegistroForm.controls["bDeBajaInternet"].setValue(
      res.bDeBajaInternet
    );
    this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue(
      res.FechaDeBajaInternet
    );
    this.editorRegistroForm.controls["Observaciones"].setValue(
      res.Observaciones
    );
    this.editorRegistroForm.controls["ObsAdvertencia"].setValue(
      res.ObsAdvertencia
    );
    this.editorRegistroForm.controls["CodIdiomaVisita"].setValue(
      res.CodIdiomaVisita
    );
    this.editorRegistroForm.controls["CodIdiomaDocumento"].setValue(
      res.CodIdiomaDocumento
    );

    // Datos de facturacion (¿ClienteAdicional?)
    this.editorRegistroForm.controls["TipoDocumentoFacturacion"].setValue(
      res.TipoDocumentoFacturacion
    );
    this.editorRegistroForm.controls["NumDocumentoFacturacion"].setValue(
      res.NumDocumentoFacturacion
    );
    this.editorRegistroForm.controls["RazonSocial"].setValue(res.RazonSocial);
    this.editorRegistroForm.controls["NombreFacturacion"].setValue(
      res.NombreFacturacion
    );
    this.editorRegistroForm.controls["PrimerApellidoFacturacion"].setValue(
      res.PrimerApellidoFacturacion
    );
    this.editorRegistroForm.controls["SegundoApellidoFacturacion"].setValue(
      res.SegundoApellidoFacturacion
    );
    this.editorRegistroForm.controls["DomicilioFacturacion"].setValue(
      res.DomicilioFacturacion
    );
    this.editorRegistroForm.controls["LocalidadFacturacion"].setValue(
      res.LocalidadFacturacion
    );
    this.editorRegistroForm.controls["ProvinciaFacturacion"].setValue(
      res.ProvinciaFacturacion
    );
    this.editorRegistroForm.controls["CodigoPostalFacturacion"].setValue(
      res.CodigoPostalFacturacion
    );
    this.editorRegistroForm.controls["PaisFacturacion"].setValue(
      res.PaisFacturacion
    );
    this.editorRegistroForm.controls["PaisCodigo"].setValue(res.PaisCodigo);

    // Datos de pago (xxxCobro)
    this.editorRegistroForm.controls["Persona"].setValue(res.Persona);
    this.editorRegistroForm.controls["Direccion"].setValue(res.Direccion);
    this.editorRegistroForm.controls["Lugar"].setValue(res.Lugar);
    this.editorRegistroForm.controls["Dias"].setValue(res.Dias);

    this.editorRegistroForm.controls["ClienteCargo"].setValue(
      res?.ClienteCargo ?? ""
    );
    this.editorRegistroForm.controls["ClienteIdiomaMercado"].setValue(
      res?.ClienteIdiomaMercado ?? ""
    );
    this.editorRegistroForm.controls["ClienteTipoMercado"].setValue(
      res?.ClienteTipoMercado ? +res.ClienteTipoMercado : ''
    );

    this.esbaja();

    if (this.listaClientes === undefined) {
      this.listaClientes = [];
    }

    if (res.Entradas) {
      this.idToList(res.Entradas, "Entradas");
      this.editorRegistroForm.controls["Entradas"].setValue(res.Entradas);
    }
    if (res.Promociones) {
      this.idToList(res.Promociones, "Promociones");
      this.editorRegistroForm.controls["Promociones"].setValue(res.Promociones);
    }
    if (res.Abonados) {
      this.idToList(res.Abonados, "Abonados");
      this.editorRegistroForm.controls["Abonados"].setValue(res.Abonados);
    }
    this.editorRegistroForm.controls["Canales"].setValue(res.Canales);

    // Mas campos nuevos
    this.editorRegistroForm.controls["Observaciones"].setValue(
      res.Observaciones
    );
    this.editorRegistroForm.controls["ObsAdvertencia"].setValue(
      res.ObsAdvertencia
    );
    this.editorRegistroForm.controls["CodIdiomaVisita"].setValue(
      res.CodIdiomaVisita
    );
    this.editorRegistroForm.controls["IdiomaVisita"].setValue(res.IdiomaVisita);
    this.editorRegistroForm.controls["CodIdiomaDocumento"].setValue(
      res.CodIdiomaDocumento
    );
    this.editorRegistroForm.controls["IdiomaDocumento"].setValue(
      res.IdiomaDocumento
    );

    this.getFechaBaja();
    this._cds.detectChanges();
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private checkPermission() {
    this.clientService.checkPermission(this.route).then((permision) => {
      this.permision = permision;
    });
  }

  actualizarContactosFormGroup() {
    let newFormGroup = [];
    for (let i = 0; this.listaContactos.length > i; i++) {
      var promocionEntradaFormControls = new FormGroup({
        Nombre: new FormControl(this.listaContactos[i].Nombre),
        PrimerApellido: new FormControl(this.listaContactos[i].PrimerApellido),
        SegundoApellido: new FormControl(
          this.listaContactos[i].SegundoApellido
        ),
        Email: new FormControl(this.listaContactos[i].Email),
        Localidad: new FormControl(this.listaContactos[i].Localidad),
        Provincia: new FormControl(this.listaContactos[i].Provincia),
      });
      newFormGroup.push(promocionEntradaFormControls);
    }
    this.ContactosFormGroup = newFormGroup;
  }

  updateListaContactos(value, index, field) {
    switch (field) {
      case "Nombre":
        this.listaContactos[index].Nombre = value;
        break;
      case "PrimerApellido":
        this.listaContactos[index].PrimerApellido = value;
        break;
      case "SegundoApellido":
        this.listaContactos[index].SegundoApellido = value;
        break;
      case "Email":
        this.listaContactos[index].Email = value;
        break;
      case "Localidad":
        this.listaContactos[index].Localidad = value;
        break;
      case "Provincia":
        this.listaContactos[index].Provincia = value;
        break;
    }
  }

  aFechaddmmyyyy(fecha: string): Date {
    if (fecha == null || fecha.length == 0) {
      return null;
    } else {
      var parts = fecha.split("/");
      if (parts[0] != "Invalid date") {
        return new Date(
          parseInt(parts[2].substring(0, 4)),
          parseInt(parts[1]) - 1,
          parseInt(parts[0])
        );
      } else {
        return null;
      }
    }
  }

  aFecha(fecha: string): Date {
    if (fecha == null || fecha.length == 0) {
      return null;
    } else {
      var parts = fecha.split("/");
      if (parts[0] != "Invalid date") {
        //
        //return new Date(parseInt(parts[0].substring(0, 4)), parseInt(parts[1]) - 1, parseInt(parts[2]));
        return new Date(
          parseInt(parts[0].substring(0, 4)),
          parseInt(parts[1]) - 1,
          parseInt(parts[2].substring(0, 2))
        );
      } else {
        return null;
      }
    }
  }

  public setDate(event, formControl): void {
    //
    this.editorRegistroForm.controls[formControl].setValue(
      moment(event.value).format("YYYY/MM/DD 0:00:00")
    );
  }

  borrarContacto(row: any) {
    // TODO: verifica que esto funciona bien

    this.listaContactos = this.listaContactos.filter((obj) => obj != row);

    this.actualizarContactosFormGroup();

    this.dataSourceContactos = new MatTableDataSource(this.listaContactos);
  }

  /* addContactoPopup() {
    const dialogRef = this.dialog.open(AddContactoPopupComponent, {
      height: '580px',
      width: '600px',
      data: {
        mensaje: 'test',
        name: 'test',
        eMails: 'test'
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      // 1 = Cancelar
      // 2 = Añadir Contacto

      switch (result.action) {
        case 1: // Cancelar
          break;
        case 2: // Añadir Contacto
          if (this.listaContactos == undefined) {
            this.listaContactos = [];
          }



          let item = new Contacto();
          // TODO::: obtener los datos del result
          item.Nombre = result.data.Nombre;
          item.PrimerApellido = result.data.PrimerApellido;
          item.SegundoApellido = result.data.SegundoApellido;
          item.Email = result.data.Email;
          item.Localidad = result.data.Localidad;
          item.Provincia = result.data.Provincia;

          this.listaContactos.push(item);

          this.actualizarContactosFormGroup()
          this.dataSourceContactos = new MatTableDataSource(this.listaContactos);



          break;
      }
    });
  } */

  addContacto() {
    if (this.listaContactos == undefined) {
      this.listaContactos = [];
    }

    this.listaContactos.push(new Contacto());

    this.actualizarContactosFormGroup();
    this.dataSourceContactos = new MatTableDataSource(this.listaContactos);
  }

  newGuardar(): void {
    //this.anadirCliente();
    let tablaContactos;
    if (this.dataSourceCliente) tablaContactos = this.dataSourceCliente.data;

    let bodyCliente = this.buildBodyClient();
    this.clienteFormGroup.value;
    // TODO::: llamar a insertarCliente, si funciona, llama a insertar contacto con el id del cliente

    this.clientesAPI.insUpdClienteNew(bodyCliente).subscribe(
      (res) => {
        if (
          res.Avisos === "Se ha insertado correctamente" ||
          res.Avisos === "Se ha modificado correctamente"
        ) {
          this.clienteFormGroup.value.forEach((item) => {
            if (item.Nombre !== null) {
              let bodyContacto = {
                idContacto: item.Id !== null ? item.Id : "",
                Nombre: item.Nombre !== null ? item.Nombre : "",
                CifoDni: "",
                Email: item.Email !== null ? item.Email : "",
                Telefono: "",
                Fax: "",
                Domicilio: "",
                Localidad: item.Localidad !== null ? item.Localidad : "",
                Provincia: item.Provincia !== null ? item.Provincia : "",
                CP: "",
                Pais: "",
                Apellido1:
                  item.PrimerApellido !== null ? item.PrimerApellido : "",
                Apellido2:
                  item.SegundoApellido !== null ? item.SegundoApellido : "",
                FechaNacimiento: "",
                PublicidadInterna: "",
                PublicidadExterna: "",
                Sexo: "",
                CodigoCliente: this.editorRegistroForm.value.Codigo,
              };

              this.clientesAPI.insUpdContacto(bodyContacto).subscribe(
                (res) => {},
                (error) => {
                  this.httpErrorService.identificarErrores(error);
                }
              );
            }
          });
          this.save();
          this.snackvar_service.openSnackBar(
            "Se ha guardado correctamente",
            "",
            "green-snackbar"
          );
          this.destroy();
        }
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        this.snackvar_service.openSnackBar(error, "", "red-snackbar");
        this.loading = false;
      }
    );
  }

  private syncInputFilterHiddensToForm(): void {
    const list = this.inputFilterCmps;
    if (!list || list.length === 0) {
      return;
    }
    list.forEach((cmp) => {
      const name = cmp.formControlText;
      if (!name) {
        return;
      }
      const ctrl = this.editorRegistroForm.get(name);
      if (!ctrl) {
        return;
      }
      const v = cmp.getSyncValueForParentForm();
      ctrl.setValue(v);
      ctrl.updateValueAndValidity({ emitEvent: false });
    });
  }

  private normalizeCustomerIdForPayload(raw: string): string {
    const maxLen = 50;
    const s = String(raw ?? "").trim();
    if (!s) {
      return "";
    }
    const norm = (x: string) => x.trim().replace(/  +/g, " ");
    const sn = norm(s);
    const rows = this.listaCustomerId ?? [];

    const idFromRow = (row: any): string =>
      row?.Id != null ? norm(String(row.Id)) : "";

    if (rows.length > 0) {
      for (const row of rows) {
        const id = idFromRow(row);
        const nom = row?.Nombre != null ? norm(String(row.Nombre)) : "";
        if (id && (id === sn || nom === sn)) {
          return id.substring(0, maxLen);
        }
      }
      const slash = sn.indexOf(" / ");
      if (slash > 0) {
        const prefix = norm(sn.substring(0, slash));
        for (const row of rows) {
          const id = idFromRow(row);
          if (id && id === prefix) {
            return id.substring(0, maxLen);
          }
        }
      }
      return "";
    }

    const slash = sn.indexOf(" / ");
    if (slash > 0) {
      return sn.substring(0, slash).trim().substring(0, maxLen);
    }
    return sn.substring(0, maxLen);
  }

  /** `Cliente.Contactos.ListadoContacto` na API InsertarActualizarCustomanCliente. */
  private buildListadoContactoParaCliente(): any[] {
    if (!this.clienteFormGroup?.length) {
      return [];
    }
    const out: any[] = [];
    for (const ctrl of this.clienteFormGroup.controls) {
      const row = (ctrl as FormGroup).value;
      if (!row) {
        continue;
      }
      const nombre = (row.Nombre ?? "").toString().trim();
      const idVal = row.Id;
      const hasId = idVal != null && String(idVal).trim() !== "";
      if (!nombre && !hasId) {
        continue;
      }
      const item: any = {
        Nombre: nombre,
        Apellido1: (row.PrimerApellido ?? "").toString(),
        Apellido2: (row.SegundoApellido ?? "").toString(),
        Email: (row.Email ?? "").toString(),
        Localidad: (row.Localidad ?? "").toString(),
        Provincia: (row.Provincia ?? "").toString(),
      };
      if (hasId) {
        item.pkId = String(idVal).trim();
      }
      out.push(item);
    }
    return out;
  }

  buildBodyClient() {
    this.syncInputFilterHiddensToForm();

    let SelectedNombrePais;

    if (this.editorRegistroForm.value.PaisCodigo.trim() != "") {
      let SelectedPais;

      SelectedPais = this.listaPaises.filter(
        (e) => e.CodPais == this.editorRegistroForm.value.PaisCodigo
      );
      if (SelectedPais[0]) SelectedNombrePais = SelectedPais[0].NombrePais;
    } else {
      SelectedNombrePais = "";
    }

    const v = this.editorRegistroForm.value;
    const toInt = (val: any) => {
      const n = val !== null && val !== undefined && val !== "" ? parseInt(String(val), 10) : NaN;
      return Number.isFinite(n) ? n : 0;
    };
    const toBool = (val: any) => val === true || val === "1";
    const toDecimal = (val: any) => {
      const n = val !== null && val !== undefined && val !== "" ? parseFloat(String(val).replace(",", ".")) : NaN;
      return Number.isFinite(n) ? n : 0;
    };

    let bodyCliente = {
      RegistrarModificar: this.RegistrarModificar,
      DatosComunes: {
        CodigoCliente: toInt(v.Codigo),
        CodigoClientePadre: v.TieneClientePadre ? toInt(v.ClientePadreId) : 0,
        TipoDocumento: v.TipoDocumento,
        CIFoDNI: v.NumDocumento,
        ImprimirEnTicket: toBool(v.ImprimirEnTicket),
        NombreCliente: v.NombreCliente,
        PrimerApellido: this.detalleCliente?.DatosComunes?.PrimerApellido ? this.detalleCliente.DatosComunes.PrimerApellido : "",
        SegundoApellido: this.detalleCliente?.DatosComunes?.SegundoApellido ? this.detalleCliente.DatosComunes.SegundoApellido : "",
        PrefijoInternacional: v.PrefijoInternacional,
        Telefono: v.Telefono1,
        Movil: v.Movil,
        Domicilio: v.Domicilio,
        Localidad: v.Localidad,
        Provincia: v.Provincia,
        CP: v.CodigoPostal,
        Pais: SelectedNombrePais,
        Nacionalidad: v.Nacionalidad,
        PersonaCobro: v.Persona,
        DireccionCobro: v.Direccion,
        LugarCobro: v.Lugar,
        DiaPago: v.Dias,
        NoValidar: true,
        CustomerId: this.normalizeCustomerIdForPayload(
          v.CustomerId != null ? String(v.CustomerId) : ""
        ),
      },
      Cliente: {
        TipoPagoId: toInt(v.FormaDePago),
        TipoClienteId: toInt(v.TipoCliente),
        NombreComercial: v.NombreComercial,
        EMail: v.CorreoElectronico,
        EMail2: v.CorreoElectronico2,
        Telefono2: v.Telefono2,
        CodigoGrupos: toInt(v.GrupoCliente),
        CodigoZonaComercial: toInt(v.ZonaComercial),
        DeBaja: toBool(v.bDeBaja),
        FechaBaja: v.FechaDeBaja,
        FechaAlta: v.FechaDeAltaTaquilla,
        TieneDescuento: toBool(v.DescuentoTaquilla),
        TipoDescuento: v.TipoDescuentoTaquilla,
        CantidadDescuento: toDecimal(v.ImporteDescuentoTaquilla),
        RedondeoPrecios: toBool(v.RedondearPrecioTaquilla),
        TicketSinDescuento: toBool(v.TicketSinDescuentoTaquilla),
        FraccionamientoPago: 0,
        Canales: (v.Canales != null ? v.Canales : []).toString(),
        TieneCredito: toBool(v.TieneCredito),
        LimitesCredito: toBool(v.TieneCredito) ? this.buildCreditLimitList() : [],

        GruposEntradas: this.listToId(
          this.tiposTipoEntradaTallerAsignadas,
          "Entrada"
        ),
        GruposPromociones: this.listToId(
          this.tiposTipoPromocionTallerAsignadas,
          "Promocion"
        ),
        GruposAbonado: this.listToId(
          this.tiposTipoAbonadoTallerAsignados,
          "Abonado"
        ),
        CentrosIds: this.gsCentros.obtenercentrosAsociadosconOrden(
          this.centrosAsignados
        ),
        GruposTarifas: this.gruposTarifasService.getGruposTarifasAsignadasJoin(this.gruposTarifasAsignados),
        Contactos: {
          ListadoContacto: this.buildListadoContactoParaCliente(),
        },
      },
      ClienteInternet: {
        DeBaja: toBool(v.bDeBajaInternet),
        FechaBaja: v.FechaDeBajaInternet,
        FechaAlta: v.FechaDeAltaInternet,
        Usuario: v.Usuario,
        TieneDescuento: toBool(v.DescuentoInternet),
        TipoDescuento: v.TipoDescuentoInternet,
        CantidadDescuento: toDecimal(v.ImporteDescuentoInternet),
        RedondeoPrecios: toBool(v.RedondearPrecioInternet),
        TicketSinDescuento: toBool(v.TicketSinDescuentoInternet),
        Observaciones: v.Observaciones,
        ObsAdvertencia: v.ObsAdvertencia,
        CodIdiomaVisita: v.CodIdiomaVisita,
        CodIdiomaDocumento: v.CodIdiomaDocumento,
        VentaEnInternet: toBool(v.VentaEnInternet),
      },
      ClienteAdicional: {
        TipoDocumento: v.TipoDocumentoFacturacion,
        NumeroDocumento: v.NumDocumentoFacturacion,
        RazonSocial: v.NombreFacturacion,
        NombreClienteFactura: v.RazonSocial,
        PrimerApellido: v.PrimerApellidoFacturacion,
        SegundoApellido: v.SegundoApellidoFacturacion,
        Domicilio: v.DomicilioFacturacion,
        Localidad: v.LocalidadFacturacion,
        Provincia: v.ProvinciaFacturacion,
        CodigoPostal: v.CodigoPostalFacturacion,
        Pais: v.PaisFacturacion,
        PaisCodigo: v.PaisCodigo,

        Cargo: v.ClienteCargo ?? "",
        IdiomaAdicional: v.ClienteIdiomaMercado ?? "",
        DatosClienteMercadoId: v.ClienteTipoMercado ?? "",
        ListaDatosClienteProcedenciaIds: this.servicioAPI.getStringIds(this.procedenciasAsignadas, 'pkid'),
        ListaDatosClienteOperadorIds: this.servicioAPI.getStringIds(this.tiposOperadorAsignados, 'pkid'),
        ListaDatosClienteTurismoIds: this.servicioAPI.getStringIds(this.tiposTurismoAsignados, 'pkid'),
        VentaAPI: toBool(v.VentaAPI) ? "1" : "0"
      },
    };
    return bodyCliente;
  }


  buildCreditLimitList() {
    let bodyCreditLimit = [];
    
    const subTableList = this.ti_limite_credito_cliente.dataSource.data;

    for (const item of subTableList) {
      bodyCreditLimit.push({
        pkid: item.pkId ? item.pkId : 0,
        fechaInicio: item.FechaInicio ? item.FechaInicio.format('YYYY/MM/DD') : null,
        fechaVencimiento: item.FechaVencimiento ? item.FechaVencimiento.format('YYYY/MM/DD') : null,
        ImporteCredito: item.ImporteCredito ? String(item.ImporteCredito).replace(",", ".") : 0,
      });
    }

    return bodyCreditLimit;
  }

  /**
   * Volta a aplicar Entradas / Promoções / Abonados a partir do detalhe do cliente quando os
   * catálogos terminam de carregar (evita corrida: `changeValueForm` antes de `loadData`).
   */
  private syncEntradasPromocionesAbonadosDesdeDetalleCliente(): void {
    const c = this.detalleCliente?.Cliente;
    if (!c) {
      return;
    }
    this.idToList(c.GruposEntradas ?? "", "Entradas");
    this.idToList(c.GruposPromociones ?? "", "Promociones");
    this.idToList(c.GruposAbonado ?? "", "Abonados");
    this._cds.detectChanges();
  }

  listToId(list, type) {
    let idList = "";

    switch (type) {
      case "Entrada":
        list.forEach((element: any) => {
          const id = element?.pkId ?? element?.PkId ?? element?.GrupoId;
          if (id != null && id !== "") {
            idList = idList.concat(String(id), ",");
          }
        });
        idList = idList.endsWith(",") ? idList.slice(0, -1) : idList;
        break;
      case "Promocion":
        list.forEach((element: any) => {
          const id = element?.pkId ?? element?.PkId ?? element?.GrupoId;
          if (id != null && id !== "") {
            idList = idList.concat(String(id), ",");
          }
        });
        idList = idList.endsWith(",") ? idList.slice(0, -1) : idList;
        break;
      case "Abonado":
        list.forEach((element: any) => {
          const id = element?.pkId ?? element?.PkId ?? element?.GrupoId;
          if (id != null && id !== "") {
            idList = idList.concat(String(id), ",");
          }
        });
        idList = idList.endsWith(",") ? idList.slice(0, -1) : idList;
        break;
    }
    return idList;
  }

  idToList(list, type) {
    switch (type) {
      case "Entradas": {
        const raw = list != null && list !== "" ? String(list) : "";
        if (!raw.trim()) {
          this.tiposTipoEntradaTallerAsignadas = [];
          this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
          break;
        }
        this.tiposTipoEntradaTallerAsignadas = [];
        this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
        if (!this.tiposTipoEntrada?.length) {
          break;
        }
        raw.split(",").forEach((rawId) => {
          const id = String(rawId).trim();
          if (!id) {
            return;
          }
          const te = this.tiposTipoEntrada.find(
            (x: any) =>
              String(x.pkId ?? x.PkId ?? x.GrupoId ?? "") === id
          );
          if (!te) {
            return;
          }
          this.asignarTipoentrada({ ...te }, null);
        });
        break;
      }
      case "Promociones": {
        const raw = list != null && list !== "" ? String(list) : "";
        if (!raw.trim()) {
          this.tiposTipoPromocionTallerAsignadas = [];
          this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
          break;
        }
        this.tiposTipoPromocionTallerAsignadas = [];
        this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
        if (!this.tiposTipoPromocion?.length) {
          break;
        }
        raw.split(",").forEach((rawId) => {
          const id = String(rawId).trim();
          if (!id) {
            return;
          }
          const tp = this.tiposTipoPromocion.find(
            (x: any) => String(x.pkId ?? x.PkId ?? x.GrupoId ?? "") === id
          );
          if (!tp) {
            return;
          }
          this.asignarTipopromocion({ ...tp }, null);
        });
        break;
      }
      case "Abonados": {
        const raw = list != null && list !== "" ? String(list) : "";
        if (!raw.trim()) {
          this.tiposTipoAbonadoTallerAsignados = [];
          this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();
          break;
        }
        this.tiposTipoAbonadoTallerAsignados = [];
        this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();
        if (!this.tiposTipoAbonado?.length) {
          break;
        }
        raw.split(",").forEach((rawId) => {
          const abonadoId = String(rawId).trim();
          if (!abonadoId) {
            return;
          }
          const tp = this.tiposTipoAbonado.find(
            (x: any) =>
              String(x.pkId ?? x.PkId ?? x.GrupoId ?? "") === abonadoId
          );
          if (tp) {
            this.asignarTipoabonado({ ...tp }, null);
          }
        });
        break;
      }
    }
  }

  daTiposEntrada(): TipoEntrada[] {
    let respuesta = [];
    respuesta = this.tiposTipoEntradaTallerSinAsignar;
    respuesta = this.tiposTipoEntradaTallerAsignadas;

    return respuesta;
  }

  /**
   * `angular-dual-listbox` faz `makeId(item) => item[key]` (ex. pkId). Respostas .NET muitas vezes
   * só trazem `PkId`/`GrupoId`; sem normalizar para `pkId`, o `_id` interno fica indefinido e os
   * ítems não aparecem corretamente (em especial à direita).
   */
  private normalizePkIdForDualList(items: any[] | null | undefined): void {
    if (!items?.length) {
      return;
    }
    for (const it of items) {
      if (!it || typeof it !== "object") {
        continue;
      }
      const raw = it.pkId ?? it.PkId ?? it.GrupoId;
      if (raw != null && raw !== "") {
        it.pkId = String(raw);
      }
    }
  }

  private entradaPk(item: any): string {
    if (item == null) {
      return "";
    }
    const v = item.pkId ?? item.PkId ?? item.GrupoId;
    return v != null && v !== "" ? String(v) : "";
  }

  filtrarTiposEntrada(): TipoEntrada[] {
    if (!this.tiposTipoEntrada?.length) {
      return [];
    }
    const asignados = new Set(
      (this.tiposTipoEntradaTallerAsignadas || [])
        .map((x: any) => this.entradaPk(x))
        .filter((id: string) => !!id)
    );
    return this.tiposTipoEntrada.filter(
      (item: any) => !asignados.has(this.entradaPk(item))
    );
  }

  asignarTipoentrada(item, evento) {
    const id = this.entradaPk(item);
    if (!id) {
      return;
    }
    if (
      !this.tiposTipoEntradaTallerAsignadas.some(
        (x: any) => this.entradaPk(x) === id
      )
    ) {
      this.tiposTipoEntradaTallerAsignadas.push(item);
    }
    this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
  }

  desasignarTipoentrada(item, evento) {
    const id = this.entradaPk(item);
    this.tiposTipoEntradaTallerAsignadas = this.tiposTipoEntradaTallerAsignadas.filter(
      (x: any) => this.entradaPk(x) !== id
    );
    this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
  }

  deasignarTodas() {
    this.tiposTipoEntradaTallerAsignadas = [];
    this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
  }

  asignarTodas() {
    this.tiposTipoEntradaTallerAsignadas = (this.tiposTipoEntrada || []).slice();
    this.tiposTipoEntradaTallerSinAsignar = [];
  }

  async CargarDatosTiposEntradas(
    tipo?: number,
    recinto?: string
  ): Promise<boolean> {
    //tipo 0-null:Todas, 1:Recinto, 2:Taller/actividad
    let resultado: boolean = false;
    await this.servicioAPI.getGruposTiposEntrada().subscribe(
      (data) => {
        this.tiposTiposEntradaAPI = new TiposEntrada_Respuesta().deserialize(
          data
        );
        if (this.tiposTiposEntradaAPI.DatosResult != null) {
          switch (tipo) {
            case 1:
              this.tiposTipoEntradaTallerSinAsignar =
                this.tiposTiposEntradaAPI.DatosResult.customanGrupoTipoEntrada;
              break;
            case 2:
              this.tiposTipoEntradaTallerAsignadas =
                this.tiposTiposEntradaAPI.DatosResult.customanGrupoTipoEntrada;
              break;
            default:
              this.tiposTipoEntrada =
                this.tiposTiposEntradaAPI.DatosResult.customanGrupoTipoEntrada;
              break;
          }
          resultado = true;
        } else {
          switch (tipo) {
            case 1:
              this.tiposTipoEntradaTallerSinAsignar = [];
              break;
            case 2:
              this.tiposTipoEntradaTallerAsignadas = [];
              break;
            default:
              this.tiposTipoEntrada = [];
              break;
          }
          resultado = false;
        }
        if (this.tiposTipoEntrada?.length) {
          this.normalizePkIdForDualList(this.tiposTipoEntrada);
        }
        if (this.tiposTipoEntradaTallerSinAsignar?.length) {
          this.normalizePkIdForDualList(this.tiposTipoEntradaTallerSinAsignar);
        }
        if (this.tiposTipoEntradaTallerAsignadas?.length) {
          this.normalizePkIdForDualList(this.tiposTipoEntradaTallerAsignadas);
        }
        this.tiposTipoEntradaTallerSinAsignar = this.filtrarTiposEntrada();
        this.syncEntradasPromocionesAbonadosDesdeDetalleCliente();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );

    return resultado;
  }

  borrarCliente(index: number) {
    let clienteABorrar: any = this.listaClientes.filter((obj, i) => i == index);

    this.listaClientes.splice(index, 1);
    //this.listaClientes = this.listaClientes.filter((obj, i) => i != index);
    this.clienteFormGroup.removeAt(index);

    this.dataSourceCliente = new MatTableDataSource(this.listaClientes);

    this.clientesAPI.delContacto(clienteABorrar[0].Id).subscribe(
      (res) => {},
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  anadirCliente() {
    if (this.listaClientes === undefined) {
      this.listaClientes = [];
    }

    if (
      this.clienteFormGroup.controls.length == 0 ||
      this.validateEntradas(this.clienteFormGroup)
    ) {
      this.clienteFormGroup.push(
        this.formBuilder.group({
          Id: [""],
          Nombre: ["", [Validators.required]],
          PrimerApellido: [""],
          SegundoApellido: [""],
          Email: ["", [Validators.required]],
          Localidad: [""],
          Provincia: [""],
        })
      );
      this.listaClientes.push(new clientePlantilla()); //clientePlantilla formulario de entrada
      //this.actualizarclienteFormGroup()
      this.setDataSourceClientes();
    }
  }

  setDataSourceClientes() {
    this.listaClientes = [];

    this.clienteFormGroup.controls.forEach((element, i) => {
      if (element instanceof FormGroup) {
        let cliente = new clientePlantilla();

        cliente.Id = element.value.Id;
        cliente.Nombre = element.value.Nombre;
        cliente.PrimerApellido = element.value.PrimerApellido;
        cliente.SegundoApellido = element.value.SegundoApellido;
        cliente.Email = element.value.Email;
        cliente.Localidad = element.value.Localidad;
        cliente.Provincia = element.value.Provincia;

        this.listaClientes.push(cliente);
      }
    });
    this.dataSourceCliente = new MatTableDataSource(this.listaClientes);
  }

  validateEntradas(clienteFormGroup) {
    let ret = true;

    if (clienteFormGroup) {
      clienteFormGroup.controls.forEach((element) => {
        if (
          element instanceof FormGroup &&
          (element.value["Nombre"] == "" || element.value["Nombre"] == null)
        )
          ret = false;
      });
    }
    return ret;
  }

  hasTableRows() {
    let ret = false;
    if (!this.clienteFormGroup || this.clienteFormGroup.length < 1) ret = false;
    else ret = true;

    return ret;
  }

  validateTable(clienteFormGroup) {
    let ret = true;
    if (this.hasTableRows()) {
      if (clienteFormGroup)
        clienteFormGroup.controls.forEach((element) => {
          if (
            (element instanceof FormGroup && element.value["Nombre"] == "") ||
            element.value["Nombre"] == null
          )
            ret = false;
        });
    }
    //else {
    //  ret = false;
    //}

    return ret;
  }

  iValidezaCero(ev, form) {
    if (ev.value) form.patchValue({ iValidez: 0 });
  }

  isnovalid() {
    let ret = true;
    if (
      //this.clienteFormGroup &&
      //this.clienteFormGroup.length > 0 &&
      this.validateTable(this.clienteFormGroup) &&
      //!this.f.NumDocumento.invalid &&
      !this.f.NombreCliente.invalid &&
      //!this.f.CorreoElectronico.invalid &&
      //!this.f.Telefono1.invalid &&
      //!this.f.Domicilio.invalid &&
      //!this.f.Localidad.invalid &&
      //!this.f.Provincia.invalid &&
      //!this.f.CodigoPostal.invalid &&
      //!this.f.Nacionalidad.invalid &&
      //!this.f.FormaDePago.invalid &&
      //!this.f.ZonaComercial.invalid &&
      //!this.f.TipoCliente.invalid &&
      //!this.f.ImporteDescuentoTaquilla.invalid &&
      //!this.f.NombreFacturacion.invalid &&
      (this.f["VentaEnInternet"].value != true ||
        (!this.f.Usuario.invalid &&
          this.f.Usuario.value != "" &&
          this.f["VentaEnInternet"].value == true))
    ) {
      ret = false;
      this.tablavalida = true;
      //this._cds.detectChanges();
    } else {
      if (!this.validateTable(this.clienteFormGroup) && this.hasTableRows()) {
        this.tablavalida = false;
        //this._cds.detectChanges();
      }
    }

    return ret;
  }

  atras() {
    this.editando = false;
    this.idClienteEnEdicion = "";

    //this.clienteFormGroup.controls.forEach( e =>  { if (e instanceof FormGroup) this.clienteFormGroup.removeAt(0); });
    while (this.clienteFormGroup.length !== 0) {
      this.clienteFormGroup.removeAt(0);
    }
    this.setDataSourceClientes();
  }

  ngAfterViewChecked() {
    if (this.validateTable(this.clienteFormGroup)) {
      this.tablavalida = true;
      this._cds.detectChanges();
    } else {
      this.tablavalida = false;
      this._cds.detectChanges();
    }
  }

  daTiposPromocion(): any[] {
    let respuesta = [];
    respuesta = this.tiposTipoPromocionRecintoSinAsignar;
    respuesta = this.tiposTipoPromocionTallerAsignadas;
    return respuesta;
  }

  private promoPk(item: any): string {
    if (item == null) {
      return "";
    }
    const v = item.pkId ?? item.PkId ?? item.GrupoId;
    return v != null && v !== "" ? String(v) : "";
  }

  filtrarTiposPromocion(): any[] {
    if (!this.tiposTipoPromocion?.length) {
      return [];
    }
    const asignados = new Set(
      (this.tiposTipoPromocionTallerAsignadas || [])
        .map((x: any) => this.promoPk(x))
        .filter((id: string) => !!id)
    );
    return this.tiposTipoPromocion.filter(
      (item: any) => !asignados.has(this.promoPk(item))
    );
  }

  asignarTipopromocion(item, evento) {
    const id = this.promoPk(item);
    if (!id) {
      return;
    }
    if (
      !this.tiposTipoPromocionTallerAsignadas.some(
        (x: any) => this.promoPk(x) === id
      )
    ) {
      this.tiposTipoPromocionTallerAsignadas.push(item);
    }
    this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
  }

  desasignarTipopromocion(item, evento) {
    const id = this.promoPk(item);
    this.tiposTipoPromocionTallerAsignadas = this.tiposTipoPromocionTallerAsignadas.filter(
      (x: any) => this.promoPk(x) !== id
    );
    this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
  }

  deasignarTodasPromocion() {
    this.tiposTipoPromocionTallerAsignadas = [];
    this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
  }

  asignarTodasPromocion() {
    this.tiposTipoPromocionTallerAsignadas = (this.tiposTipoPromocion || []).slice();
    this.tiposTipoPromocionRecintoSinAsignar = [];
  }

  async CargarDatosTiposPromociones(): Promise<boolean> {
    //tipo 0-null:Todas, 1:Recinto, 2:Taller/actividad
    let resultado: boolean = false;
    await this.servicioAPI.getGrupoTipoBono().subscribe(
      (data) => {
        this.tiposTiposPromocionAPI = data;
        if (this.tiposTiposPromocionAPI.DatosResult != null) {
          this.tiposTipoPromocion =
            this.tiposTiposPromocionAPI.DatosResult.customanGrupoTipoBono;
          resultado = true;
        } else {
          this.tiposTipoPromocion = [];
          resultado = false;
        }
        if (this.tiposTipoPromocion?.length) {
          this.normalizePkIdForDualList(this.tiposTipoPromocion);
        }
        this.tiposTipoPromocionRecintoSinAsignar = this.filtrarTiposPromocion();
        this.syncEntradasPromocionesAbonadosDesdeDetalleCliente();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        resultado = false;
      }
    );
    return resultado;
  }

  daTiposAbonado(): any[] {
    return this.tiposTipoAbonadoTallerAsignados ?? [];
  }

  private abonadoPk(item: any): string {
    if (item == null) {
      return "";
    }
    const v = item.pkId ?? item.PkId ?? item.GrupoId;
    return v != null && v !== "" ? String(v) : "";
  }

  filtrarTiposAbonado(): any[] {
    if (!this.tiposTipoAbonado?.length) {
      return [];
    }
    const asignados = new Set(
      (this.tiposTipoAbonadoTallerAsignados || [])
        .map((x: any) => this.abonadoPk(x))
        .filter((id: string) => !!id)
    );
    return this.tiposTipoAbonado.filter(
      (item: any) => !asignados.has(this.abonadoPk(item))
    );
  }

  asignarTipoabonado(item, evento) {
    const id = this.abonadoPk(item);
    if (!id) {
      return;
    }
    if (
      !this.tiposTipoAbonadoTallerAsignados.some(
        (x: any) => this.abonadoPk(x) === id
      )
    ) {
      this.tiposTipoAbonadoTallerAsignados.push(item);
    }
    this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();
  }

  desasignarTipoabonado(item, evento) {
    const id = this.abonadoPk(item);
    this.tiposTipoAbonadoTallerAsignados = this.tiposTipoAbonadoTallerAsignados.filter(
      (x: any) => this.abonadoPk(x) !== id
    );
    this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();
  }

  deasignarTodasAbonado() {
    this.tiposTipoAbonadoTallerAsignados = [];
    this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();
  }

  asignarTodasAbonado() {
    this.tiposTipoAbonadoTallerAsignados = (this.tiposTipoAbonado || []).slice();
    this.tiposTipoAbonadoRecintoSinAsignar = [];
  }

  VentaInternetCheck(e) {
    const TipoCliente = this.editorRegistroForm.get("TipoCliente");
    TipoCliente.clearValidators();
    if (e.checked) {
      this.VentaInternet = true;
      this.editorRegistroForm.controls["bDeBajaInternet"].setValue(false);
      TipoCliente.setValidators(Validators.required);
      /*       var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      let todaystr = yyyy + '/' + mm + '/' + dd; */
      this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue("");
    } else {
      this.VentaInternet = false;
      // venta api no puede estar activo si venta internet no lo está
      this.VentaAPI = false;
      this.editorRegistroForm.controls["VentaAPI"].setValue(false);

      TipoCliente.clearValidators();
      this.editorRegistroForm.controls["bDeBajaInternet"].setValue(true);
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let todaystr = yyyy + "/" + mm + "/" + dd;
      this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue(
        todaystr
      );
    }
    TipoCliente.updateValueAndValidity();
  }
  VentaAPICheck(e) {
    // const TipoCliente = this.editorRegistroForm.get("TipoCliente");
    // TipoCliente.clearValidators();
    if (e.checked) {
      // si este check se pasa a activo, tambien debe activarse el de venta internet
      this.editorRegistroForm.controls["VentaEnInternet"].setValue(true);
      this.editorRegistroForm.controls["VentaEnInternet"].setValue(true);
      this.VentaInternetCheck({ checked: true } as MatSlideToggleChange);
      this.VentaAPI = true;
      // this.editorRegistroForm.controls["bDeBajaInternet"].setValue(false);
      // TipoCliente.setValidators(Validators.required);
      // this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue("");
    } else {
      this.VentaAPI = false;
      // TipoCliente.clearValidators();
      // this.editorRegistroForm.controls["bDeBajaInternet"].setValue(true);
      // var today = new Date();
      // var dd = String(today.getDate()).padStart(2, "0");
      // var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      // var yyyy = today.getFullYear();

      // let todaystr = yyyy + "/" + mm + "/" + dd;
      // this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue(
      //   todaystr
      // );
    }
    //TipoCliente.updateValueAndValidity();
  }

  onChangeBajaGeneral(ob: MatSlideToggleChange) {
    if (ob.checked) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let todaystr = yyyy + "/" + mm + "/" + dd;
      this.editorRegistroForm.controls["FechaDeBaja"].setValue(todaystr);
    }
  }

  onChangeBajaInternet(ob: MatSlideToggleChange) {
    if (ob.checked) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let todaystr = yyyy + "/" + mm + "/" + dd;
      this.editorRegistroForm.controls["FechaDeBajaInternet"].setValue(
        todaystr
      );
    }
  }

  getFechaBaja(): Date {
    return this.aFechaddmmyyyy(
      moment(this.editorRegistroForm.controls["FechaDeBaja"].value).format(
        "DD/MM/YYYY 0:00:00"
      )
    );
  }

  getFechaAlta(): Date {
    return this.aFechaddmmyyyy(
      moment(
        this.editorRegistroForm.controls["FechaDeAltaTaquilla"].value
      ).format("DD/MM/YYYY 0:00:00")
    );
  }

  getFechaDeBajaInternet(): Date {
    return this.aFechaddmmyyyy(
      moment(
        this.editorRegistroForm.controls["FechaDeBajaInternet"].value
      ).format("DD/MM/YYYY 0:00:00")
    );
  }

  getFechaDeAltaInternet(): Date {
    return this.aFechaddmmyyyy(
      moment(
        this.editorRegistroForm.controls["FechaDeAltaInternet"].value
      ).format("DD/MM/YYYY 0:00:00")
    );
  }

  getFechaDiasDePago(): Date {
    return this.aFechaddmmyyyy(
      moment(this.editorRegistroForm.controls["Dias"].value).format(
        "DD/MM/YYYY 0:00:00"
      )
    );
  }

  async CargarDatosTiposAbonados(): Promise<boolean> {
    //tipo 0-null:Todas, 1:Recinto, 2:Taller/actividad
    let resultado: boolean = false;
    await this.servicioAPI.ObtenerCustomanGrupoTipoAbonado().then(
      (data) => {
        this.tiposTiposAbonadoAPI = data;
        if (this.tiposTiposAbonadoAPI.DatosResult != null) {
          const lista = this.tiposTiposAbonadoAPI.DatosResult.Lista || [];
          this.tiposTipoAbonado = lista.map((it: any) => {
            const raw = it.pkId ?? it.PkId ?? it.GrupoId;
            const nombre =
              it.Nombre != null && it.Nombre !== ""
                ? it.Nombre
                : it.NombreGrupo;
            const nombreGrupo =
              it.NombreGrupo != null && it.NombreGrupo !== ""
                ? it.NombreGrupo
                : nombre;
            return {
              ...it,
              pkId:
                raw != null && raw !== "" ? String(raw) : it.pkId ?? it.PkId,
              Nombre: nombre,
              NombreGrupo: nombreGrupo,
            };
          });
          this.normalizePkIdForDualList(this.tiposTipoAbonado);
          resultado = true;
        } else {
          this.tiposTipoAbonado = [];
          resultado = false;
        }
        this.tiposTipoAbonadoRecintoSinAsignar = this.filtrarTiposAbonado();
        this.syncEntradasPromocionesAbonadosDesdeDetalleCliente();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
        this.tiposTipoAbonado = [];
        this.tiposTipoAbonadoRecintoSinAsignar = [];
        resultado = false;
      }
    );
    return resultado;
  }
  /*  insertDataInForm(){
    if((<HTMLInputElement>document.getElementById("FormaDePago-hidden")))
      this.editorRegistroForm.get("FormaDePago").setValue((<HTMLInputElement>document.getElementById("FormaDePago-hidden")).value)
    if((<HTMLInputElement>document.getElementById("GrupoCliente-hidden")))
      this.editorRegistroForm.get("GrupoCliente").setValue((<HTMLInputElement>document.getElementById("GrupoCliente-hidden")).value)
    if((<HTMLInputElement>document.getElementById("ZonaComercial-hidden")))
      this.editorRegistroForm.get("ZonaComercial").setValue((<HTMLInputElement>document.getElementById("ZonaComercial-hidden")).value)
    if((<HTMLInputElement>document.getElementById("TipoCliente-hidden")))
      this.editorRegistroForm.get("TipoCliente").setValue((<HTMLInputElement>document.getElementById("TipoCliente-hidden")).value)

 
  } */

  /** Igual que em tipo abonado (`syncInputFilterFromChild`): valor do `app-input-filter` → FormControl. */
  closeInputFilter(eventValues: { name?: string; value?: any }) {
    if (!eventValues?.name) {
      return;
    }
    const ctrl = this.editorRegistroForm.get(eventValues.name);
    if (!ctrl) {
      return;
    }
    let v = eventValues.value;
    if (v === "" || v === "-1" || v === undefined) {
      v = "";
    }
    ctrl.setValue(v);
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  onCloseInputFilterSubcliente(eventValues) {
    console.log({
      action: "onCloseInputFilterSubcliente",
      eventValues: eventValues,
    })
    this.editorRegistroForm.get(eventValues.name).setValue(eventValues.value);

    const subclienteControl = this.editorRegistroForm.get("ClientePadreId");

    if (subclienteControl.value) {
      this.findAndCompleteSubclient(subclienteControl.value);
    }
  }
}
